// @core/api/endpoints/team/update_team_member_role.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UpdateTeamMemberRoleRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Update team member role
 * Changes the role assigned to a team member. This affects their permissions and access within the team.
 */
export async function UpdateTeamMemberRole(
  team_id: string,
  member_id: string,
  data: UpdateTeamMemberRoleRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/members/:member_id/role`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  requestPath = requestPath.replace(':member_id', encodeURIComponent(member_id));
  const requestOptions = options;
  return client.put<Response>(requestPath, data, requestOptions);
}
